if (!window.pfRefinedGiftsReady) {
  window.pfRefinedGiftsReady=true;
  document.addEventListener('click',event=>{
    const delivery=event.target.closest('[data-open-collection-delivery]');
    if(delivery){const details=document.querySelector('#pf-cro-delivery');if(details)details.open=true;}
    const button=event.target.closest('[data-gift-interest]');
    if(!button)return;
    const block=button.closest('[data-gift-ideas]');
    if(block.dataset.giftIdeas==='product') {
      block.closest('pf-cro-product')?.dispatchEvent(new CustomEvent('pf:gift-interest',{detail:button.dataset.giftInterest}));
      return;
    }
    block.querySelectorAll('[data-gift-interest]').forEach(node=>node.setAttribute('aria-pressed',String(node===button)));
    const status=block.querySelector('[data-interest-status]');
    status.textContent=button.dataset.giftName+' · '+status.dataset.selectedCopy;
    block.closest('.pf-collection').querySelectorAll('.pf-bouquet__link').forEach(link=>{
      const url=new URL(link.href,location.origin);url.searchParams.set('pf_interest',button.dataset.giftInterest);link.href=url.href;
    });
  });
}
